var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('footer',[_c('p',[_vm._v("Copyright © 2024 Climacool srl. Tutti i diritti riservati.")])])])}]

export { render, staticRenderFns }